import styled from 'styled-components';
import {ListTitleTextDefaultBox} from './list-title-text.default.box';
import {JACKPOT_WIDGET, RED_TIGER_JACKPOT} from "../../constants";

export const ListTitleTextMrGreenBox = styled(ListTitleTextDefaultBox)`
    background: none;
    border-left: 0;

    font-size: 2.4rem;
    letter-spacing: normal;
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        font-size: 1.6rem;
    }

    .${JACKPOT_WIDGET} & {
        border-left: 0;
    }

    .${RED_TIGER_JACKPOT} & {
        border-left: 0;
    }
`;

